export default __webpack_public_path__ + "static/media/KOD0031-min.820869e9.webp";